import { Typography } from "@/components/common/Typography/Typography"
import { classNames } from "@/utils/classNames"

interface FileSourceProps {
  source: string
}

export const FileSource: React.FC<FileSourceProps> = ({ source }) => {
  return (
    <div className="justify-self-start">
      <div
        className={classNames(
          "rounded-lg",
          "cursor-default",
          "px-2 py-1",
          "bg-grey4",
        )}
      >
        <Typography
          variant="textXS"
          className={classNames("text-grey5 hover:no-underline")}
        >
          {source === "API" ? "APP" : source}
        </Typography>
      </div>
    </div>
  )
}
